'use client'
import { useEffect, useState } from 'react'
import Link from 'next/link';
import Cookies from 'js-cookie';
import { ErrorMessage, Form, Formik, } from 'formik'
import { EmailSVG, EyeCloseSVG, EyeOpenSVG, LongArrowLeftSVG } from '@/Component/Common/SVGs/AuthSVG'
import usePost from '@/Utils/Hooks/usePost'
import { ResetPasswordAPI } from '@/Utils/APIRequest/Endpoints'
import { EmailSchema, PasswordConfirmationSchema, PasswordRexRequired, YupObject } from '@/Utils/ValidationSchema'
import PrimaryButton from '@/Component/Common/Forms/PrimaryButton';
import { LoaderSVG } from '@/Component/Common/SVGs/CommonSVG';
import FormikInput from '@/Component/Common/Forms/FormikInput';
import FormLabel from '@/Component/Common/Forms/FormLabel';
import AuthTop from '../AuthTop';
import { useTranslation } from '@/Utils/Hooks/useTranslate';
import ValidationMsg from '@/Utils/ValidationSchema/ValidationMsg';
import { useLoading } from '@/Utils/Hooks/useLoading';
import SkeletonLoader from '@/Layout/SkeletonLoader';
import { CustomToast } from '@/Utils/CustomToast';

const ResetPassword = () => {
    const { translations, locale } = useTranslation();
    const { skeletonLoading, startSkeletonLoading, stopSkeletonLoading } = useLoading();
    const [visiblePassword, setVisiblePassword] = useState('password');
    const [visibleConfirmPassword, setVisibleConfirmPassword] = useState('password');
    const [getForgotCookieEmail, setGetForgotCookieEmail] = useState<any>(null);

    const { data, isPending, mutate } = usePost(ResetPasswordAPI, '/login', null, null)

    useEffect(() => {
        let forgotCookie = Cookies.get('forgot_email')
        setGetForgotCookieEmail(forgotCookie)
        if (data?.status === 200 || data?.status === 201) {
            Cookies.remove('forgot_email')
            CustomToast('success', translations.setMessage)
        }
    }, [isPending])

    useEffect(() => {
        startSkeletonLoading();
        setTimeout(() => {
            stopSkeletonLoading();
        }, 1000);
    }, [])

    const handleChange = (e, setFieldValue) => {
        const { name, value } = e.target
        setVisiblePassword('password')
        setFieldValue(name, value)
    }

    const handleChange2 = (e, setFieldValue) => {
        const { name, value } = e.target
        setVisibleConfirmPassword('password')
        setFieldValue(name, value)
    }

    return (
        <div className='mx-auto max-w-xl flex flex-col h-full'>
            <AuthTop skeletonLoading={skeletonLoading} logoutBtn={false} translations={translations} />
            <Link href='/verify-otp' className='flex mb-8'>
                <LongArrowLeftSVG />
            </Link>
            <h1 className='font-semibold lg:text-4xl sm:text-3xl xs:text-2xl text-xl mb-1 !leading-tight'>{skeletonLoading ? <SkeletonLoader height={60} rows={1} /> : translations.resetPasswordTitle}</h1>
            {/* <p className='text-gray'>{skeletonLoading ? <SkeletonLoader  width="276" height={24} rows={1} /> : translations.resetPasswordSubTitle}</p> */}
            <div className='flex-1'>
                <Formik
                    initialValues={{ password: '', confirm_password: '', }}
                    validationSchema={YupObject({
                        password: PasswordRexRequired(translations),
                        confirm_password: PasswordConfirmationSchema(translations),
                    })}
                    onSubmit={(values: any) => {
                        values['language'] = locale
                        values['email'] = getForgotCookieEmail
                        mutate(values)
                    }}
                >
                    {({ errors, touched, setFieldValue, values }) => (
                        <Form className='sm:mt-10 mt-8 '>
                            <div className='grid grid-cols-12 sm:gap-5 gap-3.5 mb-7'>
                                <div className="col-span-12">
                                    <FormLabel title={translations.createPassword} skeletonLoading={skeletonLoading} />
                                    <div className="relative">
                                        <FormikInput customClass='pr-10' inputProps={{ type: visiblePassword, name: "password", onChange: (e) => handleChange(e, setFieldValue), placeholder: `${translations.createPasswordPlaceholder}`, autoComplete: "new-password" }} skeletonLoading={skeletonLoading} />
                                        <span onClick={() => setVisiblePassword((prev) => prev == 'password' ? 'text' : 'password')}>
                                            {visiblePassword == 'text' ? <EyeOpenSVG customClass='absolute top-[50%] translate-y-[-50%] right-3 cursor-pointer' /> : <EyeCloseSVG customClass='absolute top-[50%] translate-y-[-50%] right-3 cursor-pointer' />}
                                        </span>
                                    </div>
                                    <ErrorMessage name="password" component="div" render={(msg) =>
                                        <ValidationMsg errorMsg={msg} />
                                    } />
                                </div>
                                <div className="col-span-12">
                                    <FormLabel title={translations.reEnterPassword} skeletonLoading={skeletonLoading} />
                                    <div className="relative">
                                        <FormikInput customClass='pr-10' inputProps={{ type: visibleConfirmPassword, name: "confirm_password", onChange: (e) => handleChange2(e, setFieldValue), placeholder: `${translations.reEnterPasswordPlaceholder}`, autoComplete: "new-password1" }} skeletonLoading={skeletonLoading} />
                                        <span onClick={() => setVisibleConfirmPassword((prev) => prev == 'password' ? 'text' : 'password')}>
                                            {visibleConfirmPassword == 'text' ? <EyeOpenSVG customClass='absolute top-[50%] translate-y-[-50%] right-3 cursor-pointer' /> : <EyeCloseSVG customClass='absolute top-[50%] translate-y-[-50%] right-3 cursor-pointer' />}
                                        </span>
                                    </div>
                                    <ErrorMessage name="confirm_password" component="div" render={() =>
                                        <ValidationMsg errorMsg={translations.passwordMatch} />
                                    } />
                                </div>
                            </div>
                            <PrimaryButton customClass='w-full mt-7 flex items-center justify-center !py-3' buttonType='submit' disabled={isPending} skeletonLoading={skeletonLoading} width={'100%'}>
                                {translations.submit}
                                {isPending && <LoaderSVG customClass='ml-2.5' />}
                            </PrimaryButton>
                        </Form>
                    )}
                </Formik>
            </div>
            {/* <AuthBottom title="Don't have an account?" link="/register" linkText="Register Now" /> */}
        </div>
    )
}

export default ResetPassword
